import { EditorController } from '@ibiz-template/runtime';
import { ICheckBox } from '@ibiz/model-core';

/**
 * 开关编辑器控制器
 *
 * @export
 * @class SwitchEditorController
 * @extends {EditorController}
 */
export class SwitchEditorController extends EditorController<ICheckBox> {}
